<template>
    <div class="main-carousel-img">
        <img v-lazy="src" alt="">
    </div>
</template>

<script>
export default {
    props: {
        src: String,
    },
}
</script>

<style scoped>
/* 轮播图图片 */
.main-carousel-img{
    position: relative;
    width: 900px;
    height: 400px;
    overflow: hidden;
}
.main-carousel-img>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
</style>
